import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import { ArrowsClockwise, CalendarCheck, Pause, CaretRight, CaretDown, CaretUp } from "@phosphor-icons/react";

export default function RecurringDashboardWidget({ refreshKey, onManage, onOpenTask, collapsed, onToggleCollapse }) {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/recurring/dashboard"); setData(data); } catch {}
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  if (!data) return null;
  const active = data.recurring || [];
  const paused = data.paused || [];
  const upcoming = data.upcoming || [];
  if (active.length === 0 && paused.length === 0) return null;

  return (
    <div data-testid="recurring-widget" className="bg-[#DCFCE7] border-2 border-black rounded-xl hard-shadow-sm p-4 mb-6">
      <div className={`flex items-center justify-between ${collapsed ? "" : "mb-3"}`}>
        <div className="flex items-center gap-2"><ArrowsClockwise size={20} weight="bold" /><h3 className="font-display font-bold">Recurring Tasks</h3></div>
        <div className="flex items-center gap-2">
          <button data-testid="recurring-manage-btn" onClick={onManage} className="press inline-flex items-center gap-1 text-xs font-bold px-3 py-1 rounded-full bg-white border-2 border-black">
            Manage <CaretRight size={12} weight="bold" />
          </button>
          {onToggleCollapse && (
            <button data-testid="collapse-recurring" onClick={onToggleCollapse} title={collapsed ? "Expand" : "Collapse"} className="press w-8 h-8 rounded-full border-2 border-black bg-white flex items-center justify-center shrink-0">
              {collapsed ? <CaretDown size={15} weight="bold" /> : <CaretUp size={15} weight="bold" />}
            </button>
          )}
        </div>
      </div>

      {!collapsed && (<>
      <div className="flex gap-2 mb-3">
        <span data-testid="recurring-active-count" className="text-xs font-bold px-3 py-1 rounded-full border-2 border-black bg-white">{active.length} active</span>
        {paused.length > 0 && <span className="text-xs font-bold px-3 py-1 rounded-full border-2 border-black bg-[#FEF9C3] flex items-center gap-1"><Pause size={12} weight="bold" />{paused.length} paused</span>}
      </div>

      <div className="space-y-2">
        {upcoming.slice(0, 4).map((s) => (
          <button key={s.id} data-testid={`recurring-item-${s.id}`} onClick={onManage}
            className="press w-full text-left flex items-center gap-3 bg-white border-2 border-black rounded-lg p-3">
            <div className="w-9 h-9 rounded-full border-2 border-black bg-[#DCFCE7] flex items-center justify-center shrink-0"><CalendarCheck size={16} weight="bold" /></div>
            <div className="min-w-0 flex-1">
              <p className="font-bold text-sm leading-tight truncate">{s.title}</p>
              <p className="text-xs text-black/50 capitalize">{(s.recurrence_type || "").replace(/_/g, " ")} · next {s.next_occurrence_at || "—"} · {s.default_time}</p>
            </div>
          </button>
        ))}
        {upcoming.length === 0 && active.length > 0 && <p className="text-sm text-black/50">No upcoming occurrences scheduled.</p>}
      </div>
      </>)}
    </div>
  );
}
